import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/bond/footer';
import Header from '../components/bond/header';
import HomePage from '../pages/bond/home_page';
import AboutPage from '../pages/bond/about_page';
import ContactPage from '../pages/bond/contact_page';
import Membership from '../pages/bond/membership_page';

export default function BondTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                contactPage={ContactPage}
                aboutPage={AboutPage}
                membershipPage={Membership}
            />
            <Footer />
        </React.Fragment>
    )
}
